// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_fd-0";